// extracted by mini-css-extract-plugin
export default {"ButtonTiny":"style_ButtonTiny__yP98L"};